import 'focus-visible'

import { gsap, DrawSVGPlugin, ScrollTrigger } from 'gsap/all'
import { isProduction } from 'helpers'
import { scrollers } from 'utility/scrollers'
import { overlayGrid } from 'utility/overlay-grid'

import accordion from './components/accordion'
import graphCard from './components/graph-card'
import header from './sections/header'
import hero from './sections/hero'
import heroNumbers from './sections/hero-numbers'
import videoBlock from './blocks/video-block'

const app = {
  init(): void {
    gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger)

    accordion.init()
    graphCard.init()
    header.init()
    hero.init()
    heroNumbers.init()
    videoBlock.init()
    scrollers.init()

    // Loaded last...
    !isProduction && overlayGrid.init()
  },
}

document.addEventListener('DOMContentLoaded', (): void => {
  setTimeout((): void => {
    document.querySelector('.body').classList.remove('preload')
  }, 100)

  app.init()
})
